export default __webpack_public_path__ + "images/a4683469e74d23113bb9c41f09caabcb-phoenix_mobile.webp";